import type { FaireProductEntity } from "../../entity_types/product";

export const p_uctnb2jqtq: FaireProductEntity = {
  token: "p_uctnb2jqtq",
  type: "product",
  name: "Ladies Square Hard Shape EVIL EYE Theme Clutch Evening Bag",
  brandToken: "b_eungak2r99",
  brandName: "Nima Accessories Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/b664f2071f1d654db40dccd673e560e900fe535f685b1328e57004ea834b1ad7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/20c92adea7e148515cc408d450294da4942e22b6d3cfac7002ac199de4e27883.jpeg",
    "https://cdn.faire.com/fastly/8969275645d5cbbf3c7bc7bb4d1ffa5138a057dabba365fc1aad7d5b76d6baed.jpeg",
    "https://cdn.faire.com/fastly/d4ed45db8f75cb25c19b75413a6d052ff966d461a93cd5b42919d73bf82af739.jpeg",
    "https://cdn.faire.com/fastly/61b7d52e7e1bb2da265f9fba72c208a60b14b6104b24a536eb2420c025d0e7f5.jpeg",
    "https://cdn.faire.com/fastly/abd598803dd0dca0e70e796eda2dbd65489fc3fb68eb9ab6b958e75f884e3f2a.jpeg",
    "https://cdn.faire.com/fastly/064be513b5b5cae6950583a8795dcb74e786bff1c0b48cc83888d1607b91b379.jpeg",
  ],
  priceDollars: 27.71,
  description:
    'Ladies Square Hard Shape EVIL EYE Theme Clutch Evening Bag\n\nCalifornia Proposition 65 warning\n"WARNING: This product may contain chemicals known to the State of California to cause cancer, birth defects or other reproductive harm". \n',
  tags: [],
  msrpDollars: 55.43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:14.686Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
